import type { TranscribeAudioResponse } from "@repo/shared/types";
import { postFormData } from "./_client";

/**
 * Upload a browser-recorded audio clip and get back its transcription.
 * The blob comes straight from MediaRecorder (typically audio/webm;codecs=opus).
 * Pass an ISO-639-1 `language` hint to stop Voxtral mis-detecting the language
 * (short Norwegian clips otherwise come back as Chinese).
 */
export function transcribeAudioClip(blob: Blob, fileName = "recording.webm", language?: string) {
  const formData = new FormData();
  formData.append("audio", blob, fileName);
  if (language) formData.append("language", language);
  return postFormData<TranscribeAudioResponse>("/internal/transcription", formData);
}
